module.exports = __webpack_public_path__ + "static/media/security.39c1ed65.svg";